import { DrugToDrugInteractionModel } from "./drugToDrugInteractionModel";
import { DrugToDiseaseInteraction } from "./drugToDiseaseInteraction";
import { DrugToFoodAlcoholInteraction } from "./drugToFoodAlcoholInteraction";

export class InteractionsDataModel {
  public medicineId: number;
  public brandName: string;
  public genericName: string;

  public allDrugsInteractionsCount: number;
  public allFoodAlcoholInteractionsCount: number;
  public allDiseaseInteractionsCount: number;

  public drugToDrugInteractions: Array<DrugToDrugInteractionModel>;
  public drugToDiseaseInteractions: Array<DrugToDiseaseInteraction>;
  public drugToFoodAlcoholInteractions: Array<DrugToFoodAlcoholInteraction>;
}